import { Link, useLocation } from "react-router-dom";
import "../styles/university-home.css";
import { BookOpen, Users, Globe } from "lucide-react";
import upsa_logo from "../assets/upsa_logo.png";

function UniversityHome() {
  const location = useLocation();
  return (
    <div className="university-home">

      {/* NAVBAR */}

      <header className="uoa-navbar">

        <div className="uoa-brand">

          <div className="uoa-logo">
          <img
            src={upsa_logo}
            alt="UPSA"
          />
        </div>

          <div>
            <p>Admissions Prototype</p>
          </div>

        </div>

        <nav>
          <a href="#programs">Programs</a>
          <a href="#about">About</a>

          <Link to={`/analyzer${location.search}`}>
            Apply
          </Link>
        </nav>

      </header>

      {/* HERO */}

      <section className="uoa-hero">

        <div className="uoa-hero-content">

          <h1>
            Discover Your Future at UPSA
          </h1>

          <p>
            Explore programs, discover your strengths,
            and find the academic path that fits you best.
          </p>

        </div>

      </section>

      {/* ANALYZER CTA */}

      <section className="analyzer-section">

        <div className="analyzer-card">

          <div className="analyzer-icon">
            💡
          </div>

          <h2>
            Not Sure What To Study?
          </h2>

          <p>
            Discover your profile and explore degree programmes that match your strengths, thinking style, and interests.
          </p>

          <Link
            to={`/analyzer${location.search}`}
            className="primary-btn"
          >
            Take Assessment
          </Link>

        </div>

      </section>

      {/* FEATURES */}

      <div className="features-grid">

            <div className="feature-card">
                <div className="feature-icon blue">
                <BookOpen size={36} strokeWidth={2.2} />
                </div>

                <h3>50+ Programs</h3>

                <p>
                Choose from a wide range of undergraduate
                and graduate programs
                </p>
            </div>

            <div className="feature-card">
                <div className="feature-icon green">
                <Users size={36} strokeWidth={2.2} />
                </div>

                <h3>Expert Faculty</h3>

                <p>
                Learn from world-renowned professors and
                researchers
                </p>
            </div>

            <div className="feature-card">
                <div className="feature-icon purple">
                <Globe size={36} strokeWidth={2.2} />
                </div>

                <h3>Global Network</h3>

                <p>
                Connect with students and alumni from
                around the world
                </p>
            </div>

            </div>
    </div>
  );
}

export default UniversityHome;